var _path, _path2, _path3, _g, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareadduser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user-add",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.545,
    height: 18.545,
    viewBox: "0 0 18.545 18.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.727,3.864A3.864,3.864,0,1,1,3.864,0,3.864,3.864,0,0,1,7.727,3.864Z",
    transform: "translate(5.409 1.545)",
    fill: "none",
    stroke: "#313b5c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,5.409C0,2.419,2.975,0,6.638,0A8.029,8.029,0,0,1,8.77.286",
    transform: "translate(2.635 11.591)",
    fill: "none",
    stroke: "#313b5c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M6.182,3.091a2.777,2.777,0,0,1-.093.719,2.885,2.885,0,0,1-.355.873,3.068,3.068,0,0,1-2.643,1.5,3.03,3.03,0,0,1-2.055-.8,2.846,2.846,0,0,1-.587-.7A3.03,3.03,0,0,1,0,3.091,3.086,3.086,0,0,1,3.091,0a3.048,3.048,0,0,1,2.3,1.028A3.079,3.079,0,0,1,6.182,3.091Z",
    transform: "translate(10.818 10.818)",
    fill: "none",
    stroke: "#313b5c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.758 12.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M2.3,0H0",
    transform: "translate(0 1.128)",
    fill: "none",
    stroke: "#313b5c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0V2.31",
    transform: "translate(1.151)",
    fill: "none",
    stroke: "#313b5c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H18.545V18.545H0Z",
    fill: "none",
    opacity: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareadduser);
export default __webpack_public_path__ + "static/media/shareadduser.a2fee3eeac08edd1187a2b748ac76a81.svg";
export { ForwardRef as ReactComponent };